import React from "react";

export function Button({ variant = "primary", className = "", disabled, ...props }) {
	const variantClass = variant === "outline" ? "grader-btn--outline" : "grader-btn--primary";
	return (
		<button
			type="button"
			className={`grader-btn ${variantClass} ${className}`.trim()}
			disabled={disabled}
			{...props}
		/>
	);
}
